module.exports = __webpack_public_path__ + "json/carpardoo/manifest.json";